import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Header from '../../../components/Header/index'
import LoadingAbsolute from '../../../components/Loading/LoadingAbsolute'
import AddGuestWhiteSvg from '../../../assets/icons/AddGuestWhiteSvg'
import SelectTesis from '../SelectTesis'
import Button from '../ProcessButtons/Button'
import GuestHistoryItem from './GuestHistoryItem'
import Modal from '../../../components/MyModal/MyModal'
import ModalBody from './ModalBody'
import { getGuestData } from '../../../helpers'
import axios from 'axios'
import Empty from '../../../components/Empty/Empty'
import { setUser } from '../../../store/userReducer'
import { persistSelectedGarden, resolveSelectedGarden } from '../services/selectedGardenStorage'

// const fakeData = [
//   {
//     id: 0,
//     title: 'Misafir Girişi',
//     guest_name: 'Mehmet Karazor',
//     giris_tipi: 'Araç', // [Araç, Yaya]
//     guest_count: 5,
//     number_plate: '42ST393',
//     tel: '05433902031',
//     durum: 'Aktif', // [Aktif, Giriş Yapıldı, İptal edildi, Süresi Doldu]
//     sms_durum: 'İletildi', // [Başarısız, İletildi, Geçersiz Numara]
//   },
//   {
//     id: 1,
//     title: 'Misafir Girişi',
//     guest_name: 'Mehmet Karazor',
//     giris_tipi: 'Araç', // [Araç, Yaya]
//     guest_count: 5,
//     number_plate: '42ST393',
//     tel: '05433902031',
//     durum: 'Giriş Yapıldı', // [Aktif, Giriş Yapıldı, İptal edildi, Süresi Doldu]
//     sms_durum: 'Başarısız', // [Başarısız, İletildi, Geçersiz Numara]
//   },
//   {
//     id: 2,
//     title: 'Misafir Girişi',
//     guest_name: 'Mehmet Karazor',
//     giris_tipi: 'Araç', // [Araç, Yaya]
//     guest_count: 5,
//     number_plate: '42ST393',
//     tel: '05433902031',
//     durum: 'Süresi Doldu', // [Aktif, Giriş Yapıldı, İptal edildi, Süresi Doldu]
//     sms_durum: 'Geçersiz Numara', // [Başarısız, İletildi, Geçersiz Numara]
//   },
// ]

const GuestProcessPage = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const data = resolveSelectedGarden(location?.state?.selectedTesis)
  const [loading, setLoading] = useState(!data)
  const [selectedTesis, setSelectedTesis] = useState(data)
  const [successSmsModal, setSuccessSmsModal] = useState(false)
  const [error, setError] = useState(null)
  const [guestData, setGuestData] = useState([])

  useEffect(() => {
    if (data) {
      setLoading(false)
      setSelectedTesis(data)
      persistSelectedGarden(data)
      dispatch(setUser(data))
    }
    setError('')

    const loadGuestData = async () => {
      if (Array.isArray(data?.tanimli_misafirler)) {
        setGuestData(data.tanimli_misafirler)
        return
      }

      try {
        const result = await getGuestData()
        setGuestData(result || [])
      } catch (error) {
        setGuestData([])
      }
    }

    loadGuestData()
  }, [data, dispatch])

  const kaliciMisafirVarMi = guestData.some((item) => item.misafir_turu === 'Kalıcı' || item.misafir_turu === 'kalici')

  const successSmsToggle = () => {
    setSuccessSmsModal(!successSmsModal)
  }

  const openAddGuestPage = () => {
    if (selectedTesis) {
      persistSelectedGarden(selectedTesis)
    }

    navigate('/hobiGuestAdd', { state: { selectedTesis: selectedTesis, kaliciMisafirVarMi: kaliciMisafirVarMi } })
  }

  const sendSmsAgain = (invitation) => {
    const id = invitation.id
    axios
      .post(
        'https://app.yanibasimdakaratay.com/api/hobi-bahce/misafir-send-sms-again',
        { id: id },
        {
          headers: {
            Authorization: JSON.parse(localStorage.getItem('token')),
          },
        }
      )
      .then((res) => {
        console.log('yeniden sms gönder')
        console.log('invitation: ', invitation)
        successSmsToggle()
      })
  }

  const cancelInvitation = (invitation) => {
    const id = invitation.id
    axios
      .delete('https://app.yanibasimdakaratay.com/api/hobi-bahce/misafir', {
        headers: {
          Authorization: JSON.parse(localStorage.getItem('token')),
        },
        data: {
          id: id,
        },
      })
      .then((res) => {
        window.location.reload()
      })
    console.log('daveti iptal et')
    console.log('invitation: ', invitation)
  }

  return (
    <>
      {loading ? <LoadingAbsolute formText={'Belgeleriniz yükleniyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header
            onClick={() => {
              if (selectedTesis) {
                persistSelectedGarden(selectedTesis)
              }

              navigate('/hobiHome', { state: { selectedTesis: selectedTesis } })
            }}
            rules={selectedTesis?.id === 2}
          />
        </div>
        <div className='container'>
          <SelectTesis data={selectedTesis} selectedItem={selectedTesis} />
          <div
            style={{
              textDecoration: 'underline',
              textUnderlineOffset: '8px',
              margin: '1.5rem 0 .3rem 0',
            }}
          >
            Misafir İşlemleri
          </div>
          <div style={{ margin: '1rem 0 1.1rem 0' }}>
            <Button text='Misafir Tanımla' background={'linear-gradient(0.65turn, #86C2A8, #205C42)'} svg={<AddGuestWhiteSvg />} onClick={openAddGuestPage}></Button>
          </div>
          <div
            style={{
              textDecoration: 'underline',
              textUnderlineOffset: '8px',
            }}
          >
            Tanımlı Misafirler
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '.8rem',
              margin: '1rem 0 3rem 0',
            }}
          >
            {guestData?.map((item) => (
              <GuestHistoryItem key={item.id} item={item} sendSmsAgain={() => sendSmsAgain(item)} cancelInvitation={() => cancelInvitation(item)} />
            ))}
            {guestData?.length === 0 ? <Empty text='Henüz tanımladığınız bir misafir bulunmamaktadır.' /> : null}
          </div>
        </div>
      </div>
      <Modal toggle={successSmsToggle} modal={successSmsModal} closeButton={true} body={<ModalBody error={error} toggle={successSmsToggle} />} setHeight={error === '' ? '19.5vh' : '26.5vh'} />
    </>
  )
}

export default GuestProcessPage
